import { useCallback, useState, useEffect, useRef } from 'react';

import { Grid, Box, Button, Typography, FormControlLabel, Checkbox, TextField, TablePagination } from '@mui/material';
import { Dialog, DateTimePicker, SelectField, Tooltip, Autocomplete } from 'style-guide';
import { Link, Route, Routes, useNavigate, useLocation } from 'react-router-dom';
import { USA_STATES } from 'constants/global-constants';
import { StyledTableCell } from 'Utils';
//import { TextField } from 'style-guide';
import {
    Table,
    TableCell,
    TableBody,
    TableContainer,
    TableRow,
    TableHead,
} from '@mui/material';
import SearchOffIcon from '@mui/icons-material/SearchOff';

import { resetOrderTableFilterSlice } from 'reducers/order-reducers/orderTableFilterSlicer'
import { REQUEST_ACTIONS } from 'utils/Communicator';
import { useDispatch, useSelector } from 'react-redux';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';

const AdvSearchDialog = ({ selectedGeneral, setSelectedGeneral, onHandleChange, subModeId, subModeData, onSubModeIdChange, STAGES_OPTIONS, stageSearch, OnStageSearchChange,
    fileNumber, setFileNumber, urgentShipment, onUrgentShipmentChange, advancedSearchDefaultStyle, resetAdvancedSearchFilter, globalSearch, setGlobalSearch,
    setSearchResult, isLoading, CircularProgress, globalSearchList, globalSearchList1, selectedLocationIndex, onSelectedLocationIndexChange, onSearchChange, setSearchSpinner,
    setSearchText, dispatch, sendRequest, failedCallback, onHandleCancelAdvSearchDialog, setOrderData, loginUser, getOrders, csvExportAdv, resetOrderTableFilterSlice, origin,
    activeSearch, setActiveSearch, setEndDate, userILSalesId, setUserILSalesId, userILSales, incotermsData, setIncotermsId, setUserFU, userFU, userFUData, rDate, setRDate,
    setLoc, cId, sId, ssId, setCId, setSId, setSSId, cList, sList, ssList, bId, setBId, bList, eDate, setEDate, usState, setUsState, ctrId, setCtrId, ctrList, stageId, setStageId,
    resetSearch, orderCount, pageSize, setPageSize, pageNum, setPageNum, sortFilter, onSortFilterChange, clearSort,
    setAirPol, setAirPod, setSeaPol, setSeaPod, airPolId, airPodId, seaPolId, seaPodId, etaStart, etaEnd, etdStart, etdEnd,
    setEtaStart, setEtaEnd, setEtdStart, setEtdEnd, reminderStart, reminderEnd, setReminderStart, setReminderEnd}) => {
    const [fName, setFName] = useState(fileNumber);
    const navigate = useNavigate();
    const {
        airPolData,
        airPoaData,
        lclPolData,
        lclPoaData,
    } = useSelector(state => state.predefinedData);
    const ageList = [{ id: null, name: "Reset" }, { id: 1, name: "> 1 Month" }, { id: 2, name: "> 2 Months" }, { id: 3, name: "> 3 Months" }];
    const locList = [{ id: null, name: "Reset" }, { id: 1, name: "NL" }, { id: 2, name: "US" }, { id: 3, name: "OTHERS" }, { id: 4, name: "EXP" }];
    const airSea = [{ id: null, name: "Reset" }, { id: 1, name: "AIR" }, { id: 2, name: "SEA" }];
    const [airSeaSel, setAirSeaSel] = useState(null);
    const [ageId, setAgeId] = useState(null);
    const [locId, setLocId] = useState(null);
    const [inco, setInco] = useState(null);
    const [fu, setFu] = useState(userFU);
    const [cIdLocal, setCIdLocal] = useState(cId);
    const [sIdLocal, setSIdLocal] = useState(sId);
    const [bIdLocal, setBIdLocal] = useState(bId);
    const [ssIdLocal, setSSIdLocal] = useState(ssId);
    const [stageIdLocal, setStageIdLocal] = useState(stageId);
    const [ilReminderDate, setIlReminderDate] = useState(rDate);
    const [uList, setUList] = useState(userFUData.filter(u => u.active != false));

    const onPageHandleChange = (_, newPage) => {
        setPageNum(newPage);
        setSearchResult(sortFilter, pageSize, newPage);
    };
    const onRowsPerPageHandleChange = event => {
        setPageSize(+event.target.value);
        setPageNum(0);
        setSearchResult(sortFilter, +event.target.value, 0);
    };

    return (
        <Grid item container flexDirection="column" flexWrap="nowrap" style={{ minHeight: "80vh", minWidth: "92vw" }}>
            <Grid item container flexDirection="row" flexWrap="nowrap" style={{ margin: "10px" }}>
                <Button variant='contained' sx={{ backgroundColor: `${selectedGeneral ? "#1976d270 !important" : "#e4e4e4"}`, textTransform: "none", height: "2.2vw", marginTop: "3px", marginLeft: "11px", width: "12%", fontSize: "1vw !important" }} onClick={() => {
                    setSelectedGeneral(true);
                }}>
                    Main
                </Button>
                <Button variant='contained' sx={{ backgroundColor: `${!selectedGeneral ? "#1976d270 !important" : "#e4e4e4"}`, textTransform: "none", height: "2.2vw", marginTop: "3px", marginLeft: "11px", width: "12%", fontSize: "1vw !important" }} onClick={() => {
                    setSelectedGeneral(false);
                }}>
                    Advanced Filters
                </Button>
                {selectedGeneral && <view style={{ maxWidth: "100%", marginLeft: "20px" }}>
                    <FormControlLabel
                        control={
                            <Checkbox checked={!activeSearch} onChange={event => setActiveSearch(!activeSearch)} />
                        }
                        label='History'
                    />
                </view>}
            </Grid>
            {!selectedGeneral && <Grid>
                <Grid item container flexDirection="row" flexWrap="nowrap">
                    {/*<Grid sx={{ padding: "11px", pl: 0, pr: 0, width: "16%", margin: "2px" }}>
                        <SelectField
                            sm={null}
                            md={null}
                            lg={null}
                            label={<Typography fontSize="0.8vw" fontWeight='bold'>Mode</Typography>}
                            value={subModeId}
                            onChange={event => onHandleChange(event, onSubModeIdChange)}
                            options={[{ id: null, name: 'Reset' }, ...subModeData]}
                        />
                    </Grid>
                    <Grid sx={{ padding: "11px", pl: 0, pr: 0, width: "16%", margin: "2px" }} >
                        <SelectField
                            sm={null}
                            md={null}
                            lg={null}
                            label={<Typography fontSize="0.8vw" fontWeight='bold'>Stage</Typography>}
                            options={STAGES_OPTIONS}
                            value={stageSearch}
                            onChange={event => onHandleChange(event, OnStageSearchChange)}
                        />
                    </Grid>
                    <Grid sx={{ padding: "11px", pl: 0, pr: 0, width: "16%", margin: "2px" }} >
                        <TextField
                            lg={12}
                            type="Text"
                            label='File Number'
                            value={fName}
                            onChange={event => setFName(event.target.value)}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    dispatch(setFileNumber(e.target.value));
                                }
                            }}
                        />
                    </Grid>
                    <Grid sx={{ padding: "11px", pl: 0, pr: 0, width: "20%", margin: "2px" }} >
                        <SelectField
                            sm={null}
                            md={null}
                            lg={null}
                            label={<Typography fontSize="0.8vw" fontWeight='bold'>{urgentShipment ? "Urgent Shipment": "Reset" }</Typography>}
                            options={[{ id: 0, name: 'Reset' }, { id: 1, name: 'Urgent' }, { id: 2, name: 'Not Urgent' }]}
                            value={urgentShipment ? urgentShipment : 0}
                            onChange={event => onHandleChange(event, onUrgentShipmentChange)}
                        />
                    </Grid>
                    <Grid item container sx={{ padding: "11px", pl: 0, pr: 0, width: "16%", margin: "2px" }} alignItems='center' className="headerDate" >
                        <Tooltip title='Reset Search'>
                            <SearchOffIcon style={advancedSearchDefaultStyle} fontSize='medium' onClick={() => dispatch(resetAdvancedSearchFilter(null))} />
                        </Tooltip>
                    </Grid>*/}
                </Grid>
                <Grid item container flexDirection="row" flexWrap="nowrap">
                    <Grid sx={{ padding: "11px", pl: 0, pr: 0, width: "17%", margin: "2px" }} >
                        <Autocomplete
                            field='type'
                            label='Type'
                            lg={8}
                            value={airSeaSel}
                            onChange={(ev, val) => {
                                setAirSeaSel(val);
                            }}
                            options={airSea}
                        />
                    </Grid>

                    {airSeaSel == 1 && <Grid item container flexDirection="row" flexWrap="nowrap">
                        <Grid sx={{ padding: "11px", pl: 0, pr: 0, width: "17%", margin: "2px" }} >
                            <Autocomplete
                                field='polId'
                                label='POL'
                                lg={8}
                                value={airPolId}
                                onChange={(ev, val) => {
                                    setAirPol(val);
                                }}
                                options={airPolData}
                            />
                        </Grid>
                        <Grid sx={{ padding: "11px", pl: 0, pr: 0, width: "17%", margin: "2px" }} >
                            <Autocomplete
                                field='podId'
                                label='POD'
                                lg={8}
                                value={airPodId}
                                onChange={(ev, val) => {
                                    setAirPod(val);
                                }}
                                options={airPoaData}
                            />
                        </Grid>
                    </Grid>}
                    {airSeaSel == 2 && <Grid item container flexDirection="row" flexWrap="nowrap">
                        <Grid sx={{ padding: "11px", pl: 0, pr: 0, width: "17%", margin: "2px" }} >
                            <Autocomplete
                                field='polId'
                                label='POL'
                                lg={8}
                                value={seaPolId}
                                onChange={(ev, val) => {
                                    setSeaPol(val);
                                }}
                                options={lclPolData}
                            />
                        </Grid>
                        <Grid sx={{ padding: "11px", pl: 0, pr: 0, width: "17%", margin: "2px" }} >
                            <Autocomplete
                                field='podId'
                                label='POD'
                                lg={8}
                                value={seaPodId}
                                onChange={(ev, val) => {
                                    setSeaPod(val);
                                }}
                                options={lclPoaData}
                            />
                        </Grid>
                    </Grid>}
                    {airSeaSel != 1 && airSeaSel != 2 && <Grid item container flexDirection="row" flexWrap="nowrap">
                        <Grid sx={{ padding: "11px", pl: 0, pr: 0, width: "17%", margin: "2px" }} >
                            <Autocomplete
                                field='polId'
                                label='POL'
                                disabled
                                lg={8}
                                value={airPolId}
                                onChange={(ev, val) => {
                                    setAirPol(val);
                                }}
                                options={airPolData}
                            />
                        </Grid>
                        <Grid sx={{ padding: "11px", pl: 0, pr: 0, width: "17%", margin: "2px" }} >
                            <Autocomplete
                                field='podId'
                                label='POD'
                                disabled
                                lg={8}
                                value={airPodId}
                                onChange={(ev, val) => {
                                    setAirPod(val);
                                }}
                                options={airPoaData}
                            />
                        </Grid>
                    </Grid>}
                </Grid>
                {/*{(ssIdLocal == 2 || ssIdLocal == 3) && <Grid item container flexDirection="row" flexWrap="nowrap">
                    <Grid sx={{ padding: "11px", pl: 0, pr: 0, width: "20%", margin: "2px" }} >
                        <Autocomplete
                            field='polId'
                            label='POL'
                            lg={8}
                            value={seaPolId}
                            onChange={(ev, val) => {
                                setSeaPol(val);
                            }}
                            options={lclPolData}
                        />
                    </Grid>
                    <Grid sx={{ padding: "11px", pl: 0, pr: 0, width: "20%", margin: "2px" }} >
                        <Autocomplete
                            field='podId'
                            label='POD'
                            lg={8}
                            value={seaPodId}
                            onChange={(ev, val) => {
                                setSeaPod(val);
                            }}
                            options={lclPoaData}
                        />
                    </Grid>
                </Grid>}*/}
                <Grid item container flexDirection="row" flexWrap="nowrap">
                    <Grid sx={{ padding: "11px", pl: 0, pr: 0, width: "20%", margin: "2px" }} >
                        <DateTimePicker
                            xs={3}
                            sm={3}
                            md={3}
                            label='ETA Start'
                            boldLabel="ETA Start"
                            value={etaStart}
                            isShowTime={false}
                            format="dd/MM/yy"
                            onChange={date => setEtaStart(date?.getTime())}
                        />
                    </Grid>
                    <Grid sx={{ padding: "11px", pl: 0, pr: 0, width: "20%", margin: "2px" }} >
                        <DateTimePicker
                            xs={3}
                            sm={3}
                            md={3}
                            label='ETA End'
                            boldLabel="ETA End"
                            value={etaEnd}
                            isShowTime={false}
                            format="dd/MM/yy"
                            onChange={date => setEtaEnd(date?.getTime())}
                        />
                    </Grid>
                </Grid>
                <Grid item container flexDirection="row" flexWrap="nowrap">
                    <Grid sx={{ padding: "11px", pl: 0, pr: 0, width: "20%", margin: "2px" }} >
                        <DateTimePicker
                            xs={3}
                            sm={3}
                            md={3}
                            label='ETD Start'
                            boldLabel="ETD Start"
                            value={etdStart}
                            isShowTime={false}
                            format="dd/MM/yy"
                            onChange={date => setEtdStart(date?.getTime())}
                        />
                    </Grid>
                    <Grid sx={{ padding: "11px", pl: 0, pr: 0, width: "20%", margin: "2px" }} >
                        <DateTimePicker
                            xs={3}
                            sm={3}
                            md={3}
                            label='ETD End'
                            boldLabel="ETD End"
                            value={etdEnd}
                            isShowTime={false}
                            format="dd/MM/yy"
                            onChange={date => setEtdEnd(date?.getTime())}
                        />
                    </Grid>
                </Grid>
                {/*<Grid item container flexDirection="row" flexWrap="nowrap">
                    <Grid sx={{ padding: "11px", pl: 0, pr: 0, width: "20%", margin: "2px" }} >
                        <DateTimePicker
                            xs={3}
                            sm={3}
                            md={3}
                            label='Reminder Start'
                            boldLabel="Reminder Start"
                            value={reminderStart}
                            isShowTime={false}
                            format="dd/MM/yy"
                            onChange={date => setReminderStart(date?.toISOString().replace("T", " ").split(".")[0])}
                        />
                    </Grid>
                    <Grid sx={{ padding: "11px", pl: 0, pr: 0, width: "20%", margin: "2px" }} >
                        <DateTimePicker
                            xs={3}
                            sm={3}
                            md={3}
                            label='Reminder End'
                            boldLabel="Reminder End"
                            value={reminderEnd}
                            isShowTime={false}
                            format="dd/MM/yy"
                            onChange={date => setReminderEnd(date?.toISOString().replace("T", " ").split(".")[0])}
                        />
                    </Grid>
                </Grid>*/}
                <Grid item container flexDirection="row" flexWrap="nowrap" lg={4.9} justifyContent="flex-end" style={{marginTop: "10px"}}>
                    <Button variant='contained' sx={{ backgroundColor: `${!selectedGeneral ? "#1976d270 !important" : "#e4e4e4"}`, textTransform: "none", height: "2.2vw", marginTop: "3px", marginLeft: "11px", width: "25%", fontSize: "1vw !important" }} onClick={() => {
                        setSelectedGeneral(true);
                        setSearchResult(sortFilter, pageSize, pageNum);
                    }}>
                        Search
                    </Button>
                    <Button color='secondary' onClick={() => {
                        setGlobalSearch(null);
                        setUserFU(null);
                        setCIdLocal(null);
                        setCId(null);
                        setSId(null);
                        setSIdLocal(null);
                        setBId(null);
                        setBIdLocal(null);
                        setFu(null);
                        setSSId(null);
                        setSSIdLocal(null);
                        setLocId(null);
                        setLoc(null);
                        setUsState(null);
                        setCtrId(null);
                        setEDate(null);
                        setRDate(null);
                        setIlReminderDate(null);
                        resetSearch();
                        setAirPol(null);
                        setAirPod(null);
                        setSeaPol(null);
                        setSeaPod(null);
                        setEtaStart(null);
                        setEtaEnd(null);
                        setEtdStart(null);
                        setEtdEnd(null);
                        setReminderStart(null);
                        setReminderEnd(null);
                        //setSearchResult();
                    }} variant='contained' sx={{ backgroundColor: `${!selectedGeneral ? "#1976d270 !important" : "#e4e4e4"}`, textTransform: "none", height: "2.2vw", marginTop: "3px", marginLeft: "11px", width: "25%", fontSize: "1vw !important" }}>
                        Clear
                    </Button>
                </Grid>
            </Grid>}
            {selectedGeneral && <Grid item container flexDirection="column" flexWrap="nowrap">
                <Grid item container style={{ paddingBottom: "10px", borderBottom: "1px solid grey" }} alignItems="center" flexWrap="nowrap">
                    <Grid item container lg={1.5} flexWrap="nowrap" alignItems="flex-start" style={{marginTop: "-7px"}}>
                        {/*<Grid item container justifyContent="center" alignContent="center" style={{ padding: "10px", borderRadius: "20px", border: "1px solid grey", height: "20px", width: "20px" }} title="Search (Order, File Number, Consignee, Shipper, Client Ref, PO, Container Number, Vessel Name, HAWB, MAWB, Booking Number)">
                            i
                        </Grid>*/}
                        <Grid item lg={12} >
                            <TextField
                                lg={11}
                                md={11}
                                sm={11}
                                type="Text"
                                fullWidth
                                autoFocus
                                InputProps={{
                                    sx: { height: 40 } // Sets the specific height of the input container
                                }}
                                label='Search (Order, File Number, Consignee, Shipper, Client Ref, PO)'
                                importRef={(input) => input && input.focus()} 
                                value={globalSearch}
                                onChange={event => setGlobalSearch(event.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        setGlobalSearch(e.target.value.trim());
                                        setPageNum(0);
                                        setSearchResult(sortFilter, pageSize, pageNum);
                                    }
                                }}
                            />
                        </Grid>

                    </Grid>
                    <Grid item container lg={10.5} justifyContent="flex-start" alignItems="center" flexWrap="nowrap">
                        <TableHead sx={{ width: "100%" }}>
                            <TableRow className="header" sx={{width: "100%"}}>
                                {/*<StyledTableCell colSpan="1">
                                    <view style={{ maxWidth: "100%" }}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox checked={!activeSearch} onChange={event => setActiveSearch(!activeSearch)} />
                                            }
                                            label='History'
                                        />
                                    </view>
                                </StyledTableCell>*/}
                                <StyledTableCell sx={{ padding: "2px", pl: 0, pr: 0, width: "15%", maxWidth: "15%" }}>
                                    <Autocomplete
                                        field='cId'
                                        lg={12}
                                        label='Consignee'
                                        value={cIdLocal}
                                        onChange={(f, v) => {
                                            setCId(v);
                                            setCIdLocal(v)
                                        }}
                                        options={[{ id: null, name: 'Reset' }, ...cList]}
                                    />
                                </StyledTableCell>
                                <StyledTableCell sx={{ padding: "2px", pl: 0, pr: 0, width: "15%", maxWidth: "15%" }}>
                                    <Autocomplete
                                        field='sId'
                                        lg={12}
                                        label='Shipper'
                                        value={sIdLocal}
                                        onChange={(f, v) => {
                                            setSId(v);
                                            setSIdLocal(v);
                                        }}
                                        options={[{ id: null, name: 'Reset' }, ...sList]}
                                    />
                                </StyledTableCell>
                                <StyledTableCell sx={{ padding: "2px", pl: 0, pr: 0, width: "15%", maxWidth: "15%" }}>
                                    <Autocomplete
                                        field='bId'
                                        lg={12}
                                        label='Brokers'
                                        value={bIdLocal}
                                        onChange={(f, v) => {
                                            setBId(v);
                                            setBIdLocal(v);
                                        }}
                                        options={[{ id: null, name: 'Reset' }, ...bList]}
                                    />
                                </StyledTableCell>

                                <StyledTableCell sx={{ padding: "2px", pl: 0, pr: 0, width: "7%", maxWidth: "7%" }}>
                                    {(locId === 2) ?
                                        <Autocomplete
                                            field='stateId'
                                            label='Origin'
                                            lg={12}
                                            value={usState}
                                            onChange={(f, v) => {
                                                setUsState(v);
                                                setCtrId(null);
                                            }}
                                            options={[{ id: null, name: 'Reset' }, ...USA_STATES]}
                                        /> :
                                        <Autocomplete
                                            field='ctrId'
                                            label='Origin'
                                            lg={12}
                                            value={ctrId}
                                            onChange={(f, v) => {
                                                setCtrId(v);
                                                setUsState(null);
                                            }}
                                            options={[{ id: null, name: 'Reset' }, ...ctrList]}
                                        />}
                                </StyledTableCell>
                                <StyledTableCell sx={{ padding: "2px", pl: 0, pr: 0, width: "4%", maxWidth: "4%" }}>
                                    <Autocomplete
                                        field='locId'
                                        label='W/H'
                                        lg={12}
                                        value={locId}
                                        onChange={(f, v) => {
                                            setLocId(v);
                                            var loc = locList.find(l => l.id == v)?.name;
                                            setLoc(loc === "Reset" ? "" : loc);
                                        }}
                                        options={locList}
                                    />
                                </StyledTableCell>
                                <StyledTableCell sx={{ padding: "2px", pl: 0, pr: 0, width: "4%", maxWidth: "4%" }}>
                                    <Autocomplete
                                        field='ssId'
                                        label='Mode'
                                        lg={12}
                                        value={ssIdLocal}
                                        onChange={(f, v) => {
                                            setSSId(v);
                                            setSSIdLocal(v);
                                        }}
                                        options={[{ id: null, name: 'Reset' }, ...ssList]}
                                    />
                                </StyledTableCell>
                                {/*<StyledTableCell colSpan="1">
                                    <Autocomplete
                                        field='inco'
                                        label='Incoterms'
                                        lg={12}
                                        value={inco}
                                        onChange={(f, v) => {
                                            setInco(v);
                                            setIncotermsId(v);
                                        }}
                                        options={[{ id: null, name: 'Reset' }, ...incotermsData]}
                                    />
                                </StyledTableCell>*/}
                                <StyledTableCell sx={{ padding: "2px", pl: 0, pr: 0, width: "15%", maxWidth: "15%" }}>
                                    <DateTimePicker
                                        sm={12} xs={12} md={12} lg={12}
                                        width="100%"
                                        label='Reminder Start'
                                        boldLabel="Reminder Start"
                                        value={reminderStart}
                                        isShowTime={false}
                                        format="dd/MM/yy"
                                        onChange={date => setReminderStart(date?.getTime())}
                                    />
                                </StyledTableCell>
                                <StyledTableCell sx={{ padding: "2px", pl: 0, pr: 0, width: "15%", maxWidth: "15%" }}>
                                    <DateTimePicker
                                        sm={12} xs={12} md={12} lg={12}
                                        width="100%"
                                        label='Reminder End'
                                        boldLabel="Reminder End"
                                        value={reminderEnd}
                                        isShowTime={false}
                                        format="dd/MM/yy"
                                        onChange={date => setReminderEnd(date?.getTime())}
                                    />
                                </StyledTableCell>
                                <StyledTableCell sx={{ padding: "2px", pl: 0, pr: 0, width: "7%", maxWidth: "7%" }}>
                                    <Autocomplete
                                        field='userId'
                                        label='User'
                                        lg={12}
                                        value={fu}
                                        onChange={(f, v) => {
                                            setFu(v);
                                            setUserFU(v);
                                        }}
                                        options={[{ id: null, name: 'Reset' }, ...uList]}
                                    />
                                </StyledTableCell>
                                {/*<StyledTableCell colSpan="1">
                                    <Autocomplete
                                        field='ageId'
                                        label='Age'
                                        lg={12}
                                        value={ageId}
                                        onChange={(f, v) => {
                                            setAgeId(v)
                                            if (v > 0) {
                                                var today = new Date();
                                                var priorDate = new Date(new Date().setDate(today.getDate() - 30 * v));
                                                setEndDate(priorDate.toISOString().replace("T", " ").split(".")[0]);
                                                //setEndDate(priorDate);
                                            }
                                            else {
                                                setEndDate(null);
                                            }
                                        }}
                                        options={ageList}
                                    />
                                </StyledTableCell>*/}
                                {/*<StyledTableCell sx={{ padding: "11px", pl: 0, pr: 0, width: "6vw", minWidth: "6vw", maxWidth: "6vw" }} align='center' className="headerDate">
                                    <Autocomplete
                                        field='stageId'
                                        label='Stage'
                                        lg={12}
                                        value={stageIdLocal}
                                        onChange={(f, v) => {
                                            setStageId(v)
                                            setStageIdLocal(v)
                                        }}
                                        options={STAGES_OPTIONS}
                                    />
                                </StyledTableCell>*/}
                                {/*<StyledTableCell sx={{ padding: "11px", pl: 0, pr: 0, width: "6vw", minWidth: "6vw", maxWidth: "6vw" }} align='center' className="headerDate">
                                    <DateTimePicker
                                        xs={3}
                                        sm={3}
                                        md={3}
                                        label='ETA'
                                        boldLabel="ETA"
                                        value={eDate}
                                        isShowTime={false}
                                        format="dd/MM/yy"
                                        onChange={date => setEDate(date?.toISOString())}
                                    />
                                </StyledTableCell>
                                <StyledTableCell sx={{ padding: "11px", pl: 0, pr: 0, width: "6vw", minWidth: "6vw", maxWidth: "6vw" }} align='center' className="headerDate">
                                    <DateTimePicker
                                        xs={3}
                                        sm={3}
                                        md={3}
                                        label='Reminder'
                                        boldLabel="Reminder"
                                        value={ilReminderDate}
                                        isShowTime={false}
                                        format="dd/MM/yy"
                                        onChange={(date) => {
                                            if (date) {
                                                var dt = date?.getTime();
                                                dt += 24000 * 3600;
                                                dt -= 1000;
                                                var dat = new Date(dt);
                                                setIlReminderDate(dat?.toISOString())
                                                setRDate(dat?.toISOString().replace("T", " ").split(".0")[0])
                                            }
                                            else {
                                                setIlReminderDate(null);
                                                setRDate(null);
                                            }
                                        }}
                                    />
                                </StyledTableCell>*/}
                                <StyledTableCell sx={{ padding: "2px", pl: 0, pr: 0, width: "15%", maxWidth: "15%" }}>
                                    <Grid item container flexWrap="nowrap">
                                        <Button color='secondary' onClick={() => { setPageNum(0); setSearchResult(sortFilter, pageSize, pageNum); }} variant='contained' sx={{ width: "30px", minWidth: "auto", marginLeft: "5px", marginRight: "5px", padding: "0", backgroundColor: "#1976d270 !important", height: "2vw" }}>
                                            <ManageSearchIcon />
                                        </Button>
                                        <Button color='secondary' onClick={csvExportAdv} variant='contained' sx={{ width: "30px", minWidth: "auto", marginRight: "5px", padding: "0", backgroundColor: "#1976d270 !important", height: "2vw" }}>
                                            <FileDownloadIcon />
                                        </Button>
                                        <Button color='secondary' onClick={() => {
                                            setGlobalSearch(null);
                                            setUserFU(null);
                                            setCIdLocal(null);
                                            setCId(null);
                                            setSId(null);
                                            setSIdLocal(null);
                                            setBId(null);
                                            setBIdLocal(null);
                                            setFu(null);
                                            setSSId(null);
                                            setSSIdLocal(null);
                                            setLocId(null);
                                            setLoc(null);
                                            setUsState(null);
                                            setCtrId(null);
                                            setEDate(null);
                                            setRDate(null);
                                            setIlReminderDate(null);
                                            resetSearch();
                                            setAirPol(null);
                                            setAirPod(null);
                                            setSeaPol(null);
                                            setSeaPod(null);
                                            setEtaStart(null);
                                            setEtaEnd(null);
                                            setEtdStart(null);
                                            setEtdEnd(null);
                                            setReminderStart(null);
                                            setReminderEnd(null);
                                            //setSearchResult();
                                        }} variant='contained' sx={{ width: "30px", minWidth: "auto", marginRight: "5px", padding: "0", backgroundColor: "#1976d270 !important", height: "2vw" }}>
                                            <SearchOffIcon />
                                        </Button>
                                    </Grid>
                                </StyledTableCell>
                                {/*{(loginUser.department != 4 && loginUser.authority === "Admin") && <StyledTableCell colSpan="1">
                                    <Autocomplete
                                        field='userILSalesId'
                                        label='Sales'
                                        lg={12}
                                        value={userILSalesId}
                                        onChange={(f, v) => {
                                            setUserILSalesId(v)
                                        }}
                                        options={userILSales}
                                    />
                                </StyledTableCell>}*/}
                            </TableRow>
                        </TableHead>
                        
                    </Grid>
                </Grid>
                {isLoading && <Grid item container style={{ height: "300px" }} alignItems="center" justifyContent="center">
                    <CircularProgress style={{ marginTop: "20px" }} />
                </Grid>}
                {!isLoading && <TableContainer sx={{ maxHeight: 450, minWidth: 500 }} className="orderTable">
                    <Table className="orderTable">
                        <colgroup>
                            <col style={{ width: "80px" }} />
                            <col style={{ width: "80px" }} />
                            <col style={{ width: "110px" }} />
                            <col style={{ width: "60px" }} />
                            <col style={{ width: "60px" }} />
                            <col style={{ width: "60px" }} />
                            <col style={{ width: "60px" }} />
                            <col style={{ width: "50px" }} />
                            <col style={{ width: "50px" }} />

                            <col style={{ width: "50px" }} />
                            <col style={{ width: "80px" }} />
                            <col style={{ width: "80px" }} />
                            <col style={{ width: "70px" }} />
                            <col style={{ width: "80px" }} />
                            <col style={{ width: "80px" }} />
                            <col style={{ width: "120px" }} />
                            <col style={{ width: "80px" }} />
                            <col style={{ width: "80px" }} />
                            <col style={{ width: "80px" }} />
                        </colgroup>
                        <TableHead>
                            <TableRow className="header">
                                <TableCell colSpan={1} align='center'>
                                    <Typography variant='b' style={{ marginLeft: "10px", marginRight: "10px" }}>
                                        Order
                                        <span class="sort" onClick={() => {
                                            var sort = JSON.parse(JSON.stringify(sortFilter));
                                            if (!sort.date) {
                                                sort = clearSort();
                                                sort.date = 1;
                                            } else {
                                                if (sort.date == 1) {
                                                    sort = clearSort();
                                                    sort.date = 2;
                                                } else
                                                    sort = clearSort();
                                            }
                                            onSortFilterChange(sort);
                                            setSearchResult(sort, pageSize, pageNum);
                                        }}>↕</span>
                                    </Typography>
                                </TableCell>
                                <TableCell colSpan={1} align='center'>
                                    <Typography variant='b' style={{ marginLeft: "10px", marginRight: "10px" }}>
                                        Creation
                                        <span class="sort" onClick={() => {
                                            var sort = JSON.parse(JSON.stringify(sortFilter));
                                            if (!sort.date) {
                                                sort = clearSort();
                                                sort.date = 1;
                                            } else {
                                                if (sort.date == 1) {
                                                    sort = clearSort();
                                                    sort.date = 2;
                                                } else
                                                    sort = clearSort();
                                            }
                                            onSortFilterChange(sort);
                                            setSearchResult(sort, pageSize, pageNum);
                                        }}>↕</span>
                                    </Typography>
                                </TableCell>
                                <TableCell colSpan={1} align='center' style={{ minWidth: "80px" }}>
                                    <Typography variant='b' style={{ marginLeft: "10px", marginRight: "10px" }}>
                                        Client Ref
                                        <span class="sort" onClick={() => {
                                            var sort = JSON.parse(JSON.stringify(sortFilter));
                                            if (!sort.clientref) {
                                                sort = clearSort();
                                                sort.clientref = 1;
                                            } else {
                                                if (sort.clientref == 1) {
                                                    sort = clearSort();
                                                    sort.clientref = 2;
                                                } else
                                                    sort = clearSort();
                                            }
                                            onSortFilterChange(sort);
                                            setSearchResult(sort, pageSize, pageNum);
                                        }}>↕</span>
                                    </Typography>
                                </TableCell>
                                <TableCell colSpan={2} align='center'>
                                    <Typography variant='b' style={{ marginLeft: "10px", marginRight: "10px" }}>
                                        Consignee
                                        <span class="sort" onClick={() => {
                                            var sort = JSON.parse(JSON.stringify(sortFilter));
                                            if (!sort.consignee) {
                                                sort = clearSort();
                                                sort.consignee = 1;
                                            } else {
                                                if (sort.consignee == 1) {
                                                    sort = clearSort();
                                                    sort.consignee = 2;
                                                } else
                                                    sort = clearSort();
                                            }
                                            onSortFilterChange(sort);
                                            setSearchResult(sort, pageSize, pageNum);
                                        }}>↕</span>
                                    </Typography>
                                </TableCell>
                                <TableCell colSpan={2} align='center'>
                                    <Typography variant='b' style={{ marginLeft: "10px", marginRight: "10px" }}>
                                        Shipper
                                        <span class="sort" onClick={() => {
                                            var sort = JSON.parse(JSON.stringify(sortFilter));
                                            if (!sort.shipper) {
                                                sort = clearSort();
                                                sort.shipper = 1;
                                            } else {
                                                if (sort.shipper == 1) {
                                                    sort = clearSort();
                                                    sort.shipper = 2;
                                                } else
                                                    sort = clearSort();
                                            }
                                            onSortFilterChange(sort);
                                            setSearchResult(sort, pageSize, pageNum);
                                        }}>↕</span>
                                    </Typography>
                                </TableCell>
                                {/*<TableCell colSpan={2} align='center'>
                                    <Typography variant='b' style={{ marginLeft: "10px", marginRight: "10px" }}>Salesman</Typography>
                                </TableCell>*/}
                                <TableCell colSpan={2} align='center'>
                                    <Typography variant='b' style={{ marginLeft: "10px", marginRight: "10px" }}>
                                        Broker
                                        <span class="sort" onClick={() => {
                                            var sort = JSON.parse(JSON.stringify(sortFilter));
                                            if (!sort.brooker) {
                                                sort = clearSort();
                                                sort.brooker = 1;
                                            } else {
                                                if (sort.brooker == 1) {
                                                    sort = clearSort();
                                                    sort.brooker = 2;
                                                } else
                                                    sort = clearSort();
                                            }
                                            onSortFilterChange(sort);
                                            setSearchResult(sort, pageSize, pageNum);
                                        }}>↕</span>
                                    </Typography>
                                </TableCell>
                                <TableCell colSpan={1} align='center'>
                                    <Typography variant='b' style={{ marginLeft: "10px", marginRight: "10px" }}>
                                        Mode
                                        <span class="sort" onClick={() => {
                                            var sort = JSON.parse(JSON.stringify(sortFilter));
                                            if (!sort.type) {
                                                sort = clearSort();
                                                sort.type = 1;
                                            } else {
                                                if (sort.type == 1) {
                                                    sort = clearSort();
                                                    sort.type = 2;
                                                } else
                                                    sort = clearSort();
                                            }
                                            onSortFilterChange(sort);
                                            setSearchResult(sort, pageSize, pageNum);
                                        }}>↕</span>
                                    </Typography>
                                </TableCell>
                                <TableCell colSpan={1} align='center'>
                                    <Typography variant='b' style={{ marginLeft: "10px", marginRight: "10px" }}>
                                        ETD
                                        <span class="sort" onClick={() => {
                                            var sort = JSON.parse(JSON.stringify(sortFilter));
                                            if (!sort.etd) {
                                                sort = clearSort();
                                                sort.etd = 1;
                                            } else {
                                                if (sort.etd == 1) {
                                                    sort = clearSort();
                                                    sort.etd = 2;
                                                } else
                                                    sort = clearSort();
                                            }
                                            onSortFilterChange(sort);
                                            setSearchResult(sort, pageSize, pageNum);
                                        }}>↕</span>
                                    </Typography>
                                </TableCell>
                                <TableCell colSpan={1} align='center'>
                                    <Typography variant='b' style={{ marginLeft: "10px", marginRight: "10px" }}>
                                        ETA
                                        <span class="sort" onClick={() => {
                                            var sort = JSON.parse(JSON.stringify(sortFilter));
                                            if (!sort.eta) {
                                                sort = clearSort();
                                                sort.eta = 1;
                                            } else {
                                                if (sort.eta == 1) {
                                                    sort = clearSort();
                                                    sort.eta = 2;
                                                } else
                                                    sort = clearSort();
                                            }
                                            onSortFilterChange(sort);
                                            setSearchResult(sort, pageSize, pageNum);
                                        }}>↕</span>
                                    </Typography>
                                </TableCell>
                                <TableCell colSpan={1} align='center'>
                                    <Typography variant='b' style={{ marginLeft: "10px", marginRight: "10px" }}>
                                        Origin
                                        <span class="sort" onClick={() => {
                                            var sort = JSON.parse(JSON.stringify(sortFilter));
                                            if (!sort.orgCtr) {
                                                sort = clearSort();
                                                sort.orgCtr = 1;
                                            } else {
                                                if (sort.orgCtr == 1) {
                                                    sort = clearSort();
                                                    sort.orgCtr = 2;
                                                } else
                                                    sort = clearSort();
                                            }
                                            onSortFilterChange(sort);
                                            setSearchResult(sort, pageSize, pageNum);
                                        }}>↕</span>
                                    </Typography>
                                </TableCell>
                                {/*<TableCell colSpan={1} align='center'>
                                    <Typography variant='b' style={{ marginLeft: "10px", marginRight: "10px" }}>Status</Typography>
                                </TableCell>*/}
                                <TableCell colSpan={1} align='center'>
                                    <Typography variant='b' style={{ marginLeft: "10px", marginRight: "10px" }}>
                                        POL
                                        <span class="sort" onClick={() => {
                                            var sort = JSON.parse(JSON.stringify(sortFilter));
                                            if (!sort.pol) {
                                                sort = clearSort();
                                                sort.pol = 1;
                                            } else {
                                                if (sort.pol == 1) {
                                                    sort = clearSort();
                                                    sort.pol = 2;
                                                } else
                                                    sort = clearSort();
                                            }
                                            onSortFilterChange(sort);
                                            setSearchResult(sort, pageSize, pageNum);
                                        }}>↕</span>
                                    </Typography>
                                </TableCell>
                                <TableCell colSpan={1} align='center'>
                                    <Typography variant='b' style={{ marginLeft: "10px", marginRight: "10px" }}>
                                        POD
                                        <span class="sort" onClick={() => {
                                            var sort = JSON.parse(JSON.stringify(sortFilter));
                                            if (!sort.pod) {
                                                sort = clearSort();
                                                sort.pod = 1;
                                            } else {
                                                if (sort.pod == 1) {
                                                    sort = clearSort();
                                                    sort.pod = 2;
                                                } else
                                                    sort = clearSort();
                                            }
                                            onSortFilterChange(sort);
                                            setSearchResult(sort, pageSize, pageNum);
                                        }}>↕</span>
                                    </Typography>
                                </TableCell>
                                <TableCell colSpan={1} align='center'>
                                    <Typography variant='b' style={{ marginLeft: "10px", marginRight: "10px" }}>
                                        File Number
                                        <span class="sort" onClick={() => {
                                            var sort = JSON.parse(JSON.stringify(sortFilter));
                                            if (!sort.po) {
                                                sort = clearSort();
                                                sort.po = 1;
                                            } else {
                                                if (sort.po == 1) {
                                                    sort = clearSort();
                                                    sort.po = 2;
                                                } else
                                                    sort = clearSort();
                                            }
                                            onSortFilterChange(sort);
                                            setSearchResult(sort, pageSize, pageNum);
                                        }}>↕</span>
                                    </Typography>
                                </TableCell>
                                <TableCell colSpan={1} align='center'>
                                    <Typography variant='b' style={{ marginLeft: "10px", marginRight: "10px" }}>
                                        Reminder
                                        <span class="sort" onClick={() => {
                                            var sort = JSON.parse(JSON.stringify(sortFilter));
                                            if (!sort.reminder) {
                                                sort = clearSort();
                                                sort.reminder = 1;
                                            } else {
                                                if (sort.reminder == 1) {
                                                    sort = clearSort();
                                                    sort.reminder = 2;
                                                } else
                                                    sort = clearSort();
                                            }
                                            onSortFilterChange(sort);
                                            setSearchResult(sort, pageSize, pageNum);
                                        }}>↕</span>
                                    </Typography>
                                </TableCell>
                                <TableCell colSpan={1} align='center'>
                                    <Typography variant='b' style={{ marginLeft: "10px", marginRight: "10px" }}>
                                        W/H
                                        <span class="sort" onClick={() => {
                                            var sort = JSON.parse(JSON.stringify(sortFilter));
                                            if (!sort.location) {
                                                sort = clearSort();
                                                sort.location = 1;
                                            } else {
                                                if (sort.location == 1) {
                                                    sort = clearSort();
                                                    sort.location = 2;
                                                } else
                                                    sort = clearSort();
                                            }
                                            onSortFilterChange(sort);
                                            setSearchResult(sort, pageSize, pageNum);
                                        }}>↕</span>
                                    </Typography>
                                </TableCell>
                                <TableCell colSpan={1} align='center'>
                                    <Typography variant='b'>Action</Typography>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {globalSearchList?.map((data, index) => <TableRow key={index}>
                                <TableCell colSpan={1} align='center'>
                                    <Typography variant='b' style={{ marginLeft: "10px", marginRight: "10px" }} title={data.jobNumber}>{data.jobNumber?.substring(0, 7)}</Typography>
                                </TableCell>
                                <TableCell colSpan={1} align='center'>
                                    <Typography variant='b' style={{ marginLeft: "10px", marginRight: "10px" }}>{data.date}</Typography>
                                </TableCell>
                                <TableCell colSpan={1} align='center' style={{ minWidth: "80px" }}>
                                    <Typography variant='b' style={{ marginLeft: "10px", marginRight: "10px" }} title={data.clientPo}>{data.clientPo?.substring(0, 11)}</Typography>
                                </TableCell>
                                <TableCell colSpan={2} align='center'>
                                    <Typography variant='b' style={{ marginLeft: "10px", marginRight: "10px" }} title={data.customerName}>{data.customerName?.substring(0, 11)} </Typography>
                                </TableCell>
                                <TableCell colSpan={2} align='center'>
                                    <Typography variant='b' style={{ marginLeft: "10px", marginRight: "10px" }} title={data.shipperName}>{data.shipperName?.substring(0, 11)}</Typography>
                                </TableCell>
                                <TableCell colSpan={2} align='center'>
                                    <Typography variant='b' style={{ marginLeft: "10px", marginRight: "10px" }} title={data.broker}>{data.broker?.substring(0, 11)}</Typography>
                                </TableCell>
                                <TableCell colSpan={1} align='center'>
                                    <Typography variant='b' style={{ marginLeft: "10px", marginRight: "10px" }}>{data.mode}</Typography>
                                </TableCell>
                                <TableCell colSpan={1} align='center'>
                                    <Typography variant='b' style={{ marginLeft: "10px", marginRight: "10px" }}>{data.etd.includes("NaN") ? "" : data.etd}</Typography>
                                </TableCell>
                                <TableCell colSpan={1} align='center'>
                                    <Typography variant='b' style={{ marginLeft: "10px", marginRight: "10px" }}>{data.eta.includes("NaN") ? "" : data.eta}</Typography>
                                </TableCell>
                                <TableCell colSpan={1} align='center'>
                                    <Typography variant='b' style={{ marginLeft: "10px", marginRight: "10px" }} title={data.origin}>{data.origin?.substring(0, 11)}</Typography>
                                </TableCell>
                                {/*<TableCell colSpan={1} align='center'>
                                    <Typography variant='b' style={{ marginLeft: "10px", marginRight: "10px" }}>{data.status}</Typography>
                                </TableCell>*/}
                                <TableCell colSpan={1} align='center'>
                                    <Typography variant='b' style={{ marginLeft: "10px", marginRight: "10px" }} title={data.pol}>{data.pol?.substring(0, 11)}</Typography>
                                </TableCell>
                                <TableCell colSpan={1} align='center'>
                                    <Typography variant='b' style={{ marginLeft: "10px", marginRight: "10px" }} title={data.pod}>{data.pod?.substring(0, 11)}</Typography>
                                </TableCell>
                                <TableCell colSpan={1} align='center'>
                                    <Typography variant='b' style={{ marginLeft: "10px", marginRight: "10px" }} title={data.fileNumber}>{data.fileNumber?.substring(0, 11)}</Typography>
                                </TableCell>
                                <TableCell colSpan={1} align='center'>
                                    <Typography variant='b' style={{ marginLeft: "10px", marginRight: "10px" }} title={data.rDate}>{data.rDate}</Typography>
                                </TableCell>
                                <TableCell colSpan={1} align='center'>
                                    <Typography variant='b'>{data.location}</Typography>
                                </TableCell>
                                <TableCell colSpan={1} align='center'>
                                    <Button variant='text' onClick={() => {
                                        dispatch(resetOrderTableFilterSlice(null));
                                        if (origin === "O") {
                                            if (data.location.includes("-H")) {
                                                if (data.location.includes("EXP"))
                                                    navigate("/orderHistory", { state: { name: "location", locInd: 3, tabInd: "OrdersHistory", search: data.jobNumber, searchList: globalSearchList, searchText: globalSearch, searchList1: globalSearchList1 } });
                                                if (data.location.includes("NL"))
                                                    navigate("/orderHistory", { state: { name: "location", locInd: 0, tabInd: "OrdersHistory", search: data.jobNumber, searchList: globalSearchList, searchText: globalSearch, searchList1: globalSearchList1 } });
                                                if (data.location.includes("US"))
                                                    navigate("/orderHistory", { state: { name: "location", locInd: 1, tabInd: "OrdersHistory", search: data.jobNumber, searchList: globalSearchList, searchText: globalSearch, searchList1: globalSearchList1 } });
                                                if (data.location.includes("ALL"))
                                                    navigate("/orderHistory", { state: { name: "location", locInd: 2, tabInd: "OrdersHistory", search: data.jobNumber, searchList: globalSearchList, searchText: globalSearch, searchList1: globalSearchList1 } });
                                            } else {
                                                var selLocation = selectedLocationIndex;
                                                /*setVarInterval(setInterval(() => {
                                                    clearInterval(varInterval);
                                                    dispatch(onSelectedLocationIndexChange(3));
                                                    dispatch(onSearchChange(data.jobNumber));
                                                }, 1000));*/
                                                dispatch(resetOrderTableFilterSlice(null))
                                                if (data.location === "EXP") {
                                                    if (selectedLocationIndex != 3) {
                                                        dispatch(onSelectedLocationIndexChange(3));
                                                        dispatch(onSearchChange(data.jobNumber));
                                                        selLocation = 3;
                                                    }
                                                }
                                                else if (data.location === "NL") {
                                                    if (selectedLocationIndex != 0) {
                                                        dispatch(onSelectedLocationIndexChange(0));
                                                        dispatch(onSearchChange(data.jobNumber));
                                                        selLocation = 0;
                                                    }
                                                }
                                                else if (data.location === "US") {
                                                    if (selectedLocationIndex != 1) {
                                                        dispatch(onSelectedLocationIndexChange(1));
                                                        dispatch(onSearchChange(data.jobNumber));
                                                        selLocation = 1;
                                                    }
                                                }
                                                else if (data.location === "ALL") {
                                                    if (selectedLocationIndex != 2) {
                                                        dispatch(onSelectedLocationIndexChange(2));
                                                        dispatch(onSearchChange(data.jobNumber));
                                                        selLocation = 2;
                                                    }
                                                }
                                                var dt = [];
                                                dt.push(data);
                                                var pageName = "Order";
                                                dispatch(onSearchChange(data.jobNumber));
                                                setSearchText(data.jobNumber);
                                                setSearchSpinner(true);
                                                var qp = "&selectedLocation=" + (data.location != "EXP" ? data.location : "IL");
                                                if (loginUser.department && loginUser.authority !== "Admin") {
                                                    qp += "&userVisibility=" + loginUser.department;
                                                } else if (loginUser.authority !== "Admin")
                                                    qp += "&userVisibility=1";
                                                sendRequest("/api/order/advOrders?showUnassignedOrders=true&dep=1&page=0&size=20&search=" + data.jobNumber + qp, REQUEST_ACTIONS.GET, '', {
                                                    successCallback: response => {
                                                        dispatch(onSearchChange(data.jobNumber));
                                                        setOrderData(dispatch, getOrders, response, loginUser, failedCallback);
                                                        setSearchSpinner(false);
                                                        onHandleCancelAdvSearchDialog();
                                                    },
                                                    failedCallback,
                                                });
                                            }
                                        } else {
                                            if (!data.location.includes("-H")) {
                                                if (data.location.includes("EXP"))
                                                    navigate("/home", { state: { name: "location", locInd: 3, tabInd: "OrdersHistory", search: data.jobNumber, searchList: globalSearchList, searchText: globalSearch, searchList1: globalSearchList1 } });
                                                if (data.location.includes("NL"))
                                                    navigate("/home", { state: { name: "location", locInd: 0, tabInd: "OrdersHistory", search: data.jobNumber, searchList: globalSearchList, searchText: globalSearch, searchList1: globalSearchList1 } });
                                                if (data.location.includes("US"))
                                                    navigate("/home", { state: { name: "location", locInd: 1, tabInd: "OrdersHistory", search: data.jobNumber, searchList: globalSearchList, searchText: globalSearch, searchList1: globalSearchList1 } });
                                                if (data.location.includes("ALL"))
                                                    navigate("/home", { state: { name: "location", locInd: 2, tabInd: "OrdersHistory", search: data.jobNumber, searchList: globalSearchList, searchText: globalSearch, searchList1: globalSearchList1 } });
                                            } else {
                                                var selLocation = selectedLocationIndex;
                                                /*setVarInterval(setInterval(() => {
                                                    clearInterval(varInterval);
                                                    dispatch(onSelectedLocationIndexChange(3));
                                                    dispatch(onSearchChange(data.jobNumber));
                                                }, 1000));*/
                                                dispatch(resetOrderTableFilterSlice(null))
                                                if (data.location === "EXP-H") {
                                                    if (selectedLocationIndex != 3) {
                                                        dispatch(onSelectedLocationIndexChange(3));
                                                        dispatch(onSearchChange(data.jobNumber));
                                                        selLocation = 3;
                                                    }
                                                }
                                                else if (data.location === "NL-H") {
                                                    if (selectedLocationIndex != 0) {
                                                        dispatch(onSelectedLocationIndexChange(0));
                                                        dispatch(onSearchChange(data.jobNumber));
                                                        selLocation = 0;
                                                    }
                                                }
                                                else if (data.location === "US-H") {
                                                    if (selectedLocationIndex != 1) {
                                                        dispatch(onSelectedLocationIndexChange(1));
                                                        dispatch(onSearchChange(data.jobNumber));
                                                        selLocation = 1;
                                                    }
                                                }
                                                else if (data.location === "ALL-H") {
                                                    if (selectedLocationIndex != 2) {
                                                        dispatch(onSelectedLocationIndexChange(2));
                                                        dispatch(onSearchChange(data.jobNumber));
                                                        selLocation = 2;
                                                    }
                                                }
                                                var dt = [];
                                                dt.push(data);
                                                var pageName = "Order";
                                                setSearchSpinner(true);
                                                dispatch(onSearchChange(data.jobNumber));
                                                setSearchText(data.jobNumber);
                                                var qp = "&selectedLocation=" + data.location.replace("-H", "");
                                                if (loginUser.department && loginUser.authority !== "Admin") {
                                                    qp += "&userVisibility=" + loginUser.department;
                                                } else if (loginUser.authority !== "Admin")
                                                    qp += "&userVisibility=1";
                                                if (loginUser.authority != "Admin" && loginUser.location.id == 2)
                                                    qp += "&userILId=" + loginUser.id
                                                sendRequest("/api/order/advOrders?showHistoryOrdersOnly=true&showUnassignedOrders=true&dep=1&page=0&size=1&search=" + data.jobNumber + qp, REQUEST_ACTIONS.GET, '', {
                                                    successCallback: response => {
                                                        setOrderData(dispatch, getOrders, response, loginUser, failedCallback);
                                                        setSearchSpinner(false);
                                                        onHandleCancelAdvSearchDialog();
                                                    },
                                                    failedCallback,
                                                });
                                            }
                                        }

                                    }} style={{ color: "#1976d2", textDecoration: "underline" }}>
                                        <Typography noWrap variant='button'>
                                            Open
                                        </Typography>
                                    </Button>
                                </TableCell>
                            </TableRow>)}
                        </TableBody>
                    </Table>
                </TableContainer>}

                <TablePagination
                    rowsPerPageOptions={[20, 50, 100]}
                    component='div'
                    count={orderCount}
                    rowsPerPage={pageSize}
                    page={pageNum}
                    onPageChange={onPageHandleChange}
                    onRowsPerPageChange={onRowsPerPageHandleChange}
                />
                <Grid item container justifyContent="flex-end" style={{ marginTop: "10px" }}>
                    <Button variant='text' onClick={onHandleCancelAdvSearchDialog} sx={{ padding: "0px 6px 0px 6px !important", backgroundColor: "#1976d270 !important", height: "2vw" }}>
                        <Typography noWrap variant='button'>
                            Close
                        </Typography>
                    </Button>
                </Grid>
            </Grid>}
        </Grid>
    );
};

export default AdvSearchDialog;